<template>
  <div>
    <v-overlay :value="isLoading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    <!-- MENU CONTAINER SECTION BACKGROUND -->
    <div class="menu_container_section_background">
      <div class="col-md-12 menu_container_section_container">
        <div v-for="(menu, index) in menusUsuario" :key="index" class="menu_container_section_"
          @click="handleClick(menu)">
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
import Swal from "sweetalert2";

export default {
data: () => ({
  menusAll: [],
  menusUsuario: [],
  isLoading: false,
}),

computed: {
  nivelUsuario() {
    return ls.get('nivel_user')
  }
},


created() {
  this.carregarMenus();
},

methods: {
  async carregarMenus() {
    this.isLoading = true;      
    if (this.nivelUsuario) {
      try {
        const rotasSaved = JSON.parse(ls.get('itemMenuAdministrador'))          
        if (!rotasSaved) {
          this.menusAll = await axios.get('/carregarMenus/5').then((res) => res.data);
          this.menusUsuario = this.menusAll.filter(objeto => {
            const niveis = objeto.niveis.split(',')
            return niveis.includes(`${this.nivelUsuario}`)
          })            
          ls.set('itemMenuAdministrador', JSON.stringify(this.menusUsuario))
        } else {
          this.menusUsuario = rotasSaved
        }
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento dos menus da página!', 'error');
      } finally {
        this.isLoading = false;
      }
    } else {
      Swal.fire('Erro', 'Nivél do usuário não encontrado!', 'error');
    }
  },

  handleClick(menu) {
    if (menu.isRota == 0) {
      this.$router.push(menu.url)
    } else {
      eval(menu.funcao);
    }
  }
}
}
</script>